import styled from "styled-components";
import {below} from "assets/css/media";
import RegularButton from "components/Buttons/RegularButton";

export const ButtonIcon = styled(RegularButton)`
	min-width: 40px;
	margin-left: 10px;
	width: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: 1px solid currentColor;
	${below.desktop`
		height: 40px;
		width: 40px;
		font-size: 10px;
	`};
	@media (max-width: 400px) {
		margin-left: 0;
	}

	img {
		max-width: 100%;
		max-height: 100%;
	}
`;
